import i18n from 'i18n-js';

type FavoriteCaptionParams = {
  machine?: { shortName?: string | null } | null;
  isFavorite?: boolean;
};

// Caption under the favorite/latest block: the machine that has it selected, else favorite vs last-used.
export const buildFavoriteCaption = ({ machine, isFavorite }: FavoriteCaptionParams): string => {
  if (machine) {
    return `${i18n.t('This version is currently selected on')} ${machine.shortName}`;
  }
  if (isFavorite) {
    return i18n.t('Favorite version');
  }
  return i18n.t('Last used version');
};
